import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

const groupByMap = {
  0: "Office",
  1: "Book",
  2: "Group",
};

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function TotalFigures() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [notDetails, setNotDetails] = useState(true);
  const onNotDetailsChange = useCallback(
    (event) => setNotDetails(event.target.checked),
    []
  );

  const [groupBy, setGroupBy] = useState(0);
  const onGroupByChange = useCallback(
    (event) => setGroupBy(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <SubGroup
          title="Details Range"
          className="grid grid-cols-2 col-span-2 p-4"
        >
          <div className="flex">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={notDetails}
                  onChange={onNotDetailsChange}
                  color="primary"
                />
              }
              label="All"
            />
            <TextField
              disabled={notDetails}
              className="flex-1"
              required
              variant="outlined"
              id="gameDateTime"
              label="From"
              type="date"
              value={startDate}
              size="small"
              onChange={onStartDateChange}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <TextField
            disabled={notDetails}
            required
            variant="outlined"
            id="gameDateTime"
            label="To"
            type="date"
            value={endDate}
            size="small"
            onChange={onEndDateChange}
            InputLabelProps={{ shrink: true }}
          />
        </SubGroup>
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <div>
          <SubGroup title="Group By">
            <FormControl component="fieldset">
              <RadioGroup label value={groupBy} onChange={onGroupByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Office"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Book"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Group"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Total Figures Report"
        groupBy={!notDetails ? "groupName" : null}
        getUrl={() => "/Reports/Report_Total_Figure"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          NotDetails: notDetails,
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          OrderBy: groupBy,
        })}
        getTotals={(data) => ({
          groupName: "Total",
          paymentMethod: "Total",
          total: data.reduce((acc, curr) => acc + curr.total, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        {notDetails ? (
          <TableHeaderColumn dataSort dataField="groupName">
            {groupByMap[groupBy]}
          </TableHeaderColumn>
        ) : (
          <TableHeaderColumn dataSort dataField="paymentMethod">
            Payment Method
          </TableHeaderColumn>
        )}
        <TableHeaderColumn
          dataSort
          dataField="total"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sum Current Balance
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default TotalFigures;
